var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"laudos"}},[_c('p',[_vm._v(_vm._s(_vm.$t('mensagens.laudos.selecioneUmOuMaisTerritoriosParaSolicitacaoDeLaudos')))]),_c('SelecionarTerritorio',{on:{"getIdsTerritoriosSelecionados":_vm.solicitarLaudos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }